module.exports = __webpack_public_path__ + "static/media/Expand Blue.19ff1eb4.svg";